module.exports = __webpack_public_path__ + "static/media/foodprint_app4.bab5b130.jpg";